import React from 'react';

export type DateFormatLocaleContextValue = string | null;

export const DateFormatLocaleContext =
  React.createContext<DateFormatLocaleContextValue>(null);
